class ImageZoom extends window.BAO.CustomElement() {
  connectedCallback () {
    this.els.container.element.addEventListener('click', () => {
      lazyLoadZoomMedia(this.els.container.element)
      if (
        this.els.container.element.classList.contains('prd-Detail_Zoom-enabled')
      ) {
        this.els.container.element.classList.remove('prd-Detail_Zoom-enabled')
        this.els.container.element.classList.add('prd-Detail_Zoom-zoomInIcon')
        this.els.container.element.classList.remove(
          'prd-Detail_Zoom-zoomOutIcon',
        )

        return
      }
      this.els.container.element.classList.remove('prd-Detail_Zoom-zoomInIcon')
      this.els.container.element.classList.add('prd-Detail_Zoom-zoomOutIcon')
      this.els.container.element.classList.add('prd-Detail_Zoom-enabled')

      this.els.container.element.addEventListener('mousemove', e => {
        if (
          this.els.container.element.classList.contains(
            'prd-Detail_Zoom-enabled',
          )
        ) {
          const zoomer = e.currentTarget

          const x = (e.offsetX / zoomer.offsetWidth) * 100
          const y = (e.offsetY / zoomer.offsetHeight) * 100
          zoomer.style.backgroundPosition = `${x}% ${y}%`
        }
      })
    })

    this.els.container.element.addEventListener(
      'mouseover',
      () => {
        // Preload zoom media for more responsive UX when clicked
        lazyLoadZoomMedia(this.els.container.element)
      },
      { once: true },
    )

    function lazyLoadZoomMedia (element) {
      if (!element.style.getPropertyValue('--imageZoomMedia')) {
        const media = element.getAttribute('data-image-zoom-media')
        element.style.setProperty('--imageZoomMedia', `url("${media}")`)
      }
    }
  }

  zoom () {}
}

if (!customElements.get('image-zoom')) {
  customElements.define('image-zoom', ImageZoom)
}
